import { render, staticRenderFns } from "./Sportlerverwaltung.vue?vue&type=template&id=0f8bd04e&scoped=true&"
import script from "./Sportlerverwaltung.vue?vue&type=script&lang=js&"
export * from "./Sportlerverwaltung.vue?vue&type=script&lang=js&"
import style0 from "./Sportlerverwaltung.vue?vue&type=style&index=0&id=0f8bd04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8bd04e",
  null
  
)

export default component.exports